import * as t from "io-ts";
import { BusinessSector } from "./BusinessSector";
import { FinanceProvider } from "./FinanceProvider";
import { LenderRateType } from "./LenderRateType";
import { TradeType } from "./TradeType";

export const BusinessConfig = t.intersection([
  t.type({
    show: t.union([t.literal("yes"), t.literal("no")]),
    trade_type: TradeType,
    trade_text: t.string,
    business_sector: BusinessSector,
    lender: FinanceProvider,
    lender_rate_type: LenderRateType,
  }),
  t.partial({
    extra: t.string,
  }),
]);

export interface BusinessConfig {
  show: "yes" | "no";
  trade_type: TradeType;
  trade_text: string;
  business_sector: BusinessSector;
  extra?: string;
  lender: FinanceProvider;
  lender_rate_type: LenderRateType;
}
